import { render, staticRenderFns } from "./cr_aba_messagens.vue?vue&type=template&id=570ef740&"
import script from "./cr_aba_messagens.vue?vue&type=script&lang=js&"
export * from "./cr_aba_messagens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('570ef740')) {
      api.createRecord('570ef740', component.options)
    } else {
      api.reload('570ef740', component.options)
    }
    module.hot.accept("./cr_aba_messagens.vue?vue&type=template&id=570ef740&", function () {
      api.rerender('570ef740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/crud/cr_aba_messagens.vue"
export default component.exports